/* eslint-disable @typescript-eslint/default-param-last */
import { ActionType } from '../../types/Interviews/jobRoles.types';
import { GET_JOB_ROLES } from '../../constants/ActionTypes';
import initialState from '../../store/initialState';

/**
 * Job Roles Reducer
 * @param {IJobRoles} state=initialState.jobRoles
 * @param {ActionType} action:ActionType
 * @returns {void}
 */
const jobRolesReducer = (state = initialState.jobRoles, action: ActionType) => {
  switch (action?.type) {
    case `${GET_JOB_ROLES}_SUCCESS`:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default jobRolesReducer;
